import * as Yup from 'yup'

export const CustomerOnboardingInsuranceSchema = Yup.object().shape({
  file: Yup.string().required('Insurance file is required'),
})
